module.exports = __webpack_public_path__ + "media/application/images/svgs/dropdown-16px-41a55c86211fa2b75543c4a48c49506f.svg";